export var wrapperStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  direction: 'column',
  width: {
    lg: '24.375rem'
  },
  maxWidth: '24.375rem',
  pt: 0
};
export var descriptionStyle = {
  color: 'darkGrey1',
  fontSize: 'md',
  fontWeight: 'normal'
};
export var buttonsStyle = {
  display: 'flex',
  flexFlow: 'row',
  height: 'auto',
  justifyContent: 'space-between',
  alignContent: 'baseline',
  flexDirection: 'row',
  width: '100%',
  mt: 'md',
  pb: 'md'
};
export var allowButtonGB = {
  width: '186px'
};
export var allowButtonDE = {
  width: {
    mobile: '120px',
    xs: '186px'
  }
};
export var modalBodyStyle = {
  overflow: {
    mobile: 'hidden',
    sm: 'auto'
  },
  pt: 'inherit',
  width: '100%'
};
export var modalBodyBoxStyle = {
  maxHeight: {
    sm: '66vh'
  }
};
export var modalContentStyle = {
  maxW: 'auto',
  maxH: 'auto',
  overflow: 'auto',
  height: {
    sm: 'auto'
  },
  my: 0,
  borderRadius: 'var(--xs, 0.25rem)',
  boxShadow: ' 0rem 0.25rem 0.5rem 0rem rgba(0, 0, 0, 0.35)',
  border: ' 1px solid var(--neutral-300-light-grey-4, #E0E0E0)',
  px: 0,
  position: 'fixed',
  bottom: {
    lg: 'lg',
    md: 'lg',
    sm: 'lg',
    mobile: 'md'
  },
  right: {
    lg: 'lg',
    md: 'lg',
    sm: 'lg',
    mobile: 'auto'
  },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end'
};
export var headerContentStyle = {
  my: 'sm',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  width: '100%'
};
export var delimiterModalStyle = {
  w: 'full',
  h: '0.063rem',
  bgColor: 'lightGrey4'
};
export var headerTitleStyle = {
  color: 'darkGrey1',
  justifyContent: 'flex-start',
  fontSize: 'xl',
  lineHeight: '3',
  fontFamily: 'header',
  padding: 0,
  fontWeight: 'bold'
};
export var closeButtonStyle = {
  background: 'baseWhite',
  color: 'var(--chakra-colors-darkGrey3)',
  border: '1px solid var(--chakra-colors-darkGrey3)',
  _hover: {
    boxShadow: '0rem 0.25rem 0.5rem 0rem #ccc'
  }
};
export var modalCloseButtonStyle = {
  h: 'var(--chakra-space-xl)',
  w: 'var(--chakra-space-xl)',
  ml: 'auto',
  position: 'static',
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    bgColor: 'transparent'
  },
  _active: {
    bgColor: 'transparent'
  }
};